export class TimeUtils {

  public static readonly SECOND = 1000;
  public static readonly MINUTE = 60000;
  public static readonly HOUR = 3600000;
  public static readonly DAY = 86400000;

  public static sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

}